<script lang="ts">
	import type { KYCQuestionProps } from '@app/models/api/KYCModel';
	import InputFileKYC from '$lib/elements/inputs/variants/InputFileKYC.svelte';
	import InputSelect from '$lib/elements/inputs/variants/InputSelect.svelte';
	import { TypeDocumentIdentiteEnum } from '@app/models/api/enums/TypeDocumentIdentiteEnum';
	import { t } from 'svelte-i18n';
	import { findPropsByApiKey } from '@app/utils/kyc';
	import { onMount } from 'svelte';
	import { KYCQuestionType } from '@app/enums/KYC';
	import Toggler from '$lib/elements/Toggler.svelte';
	export let props: KYCQuestionProps;
	let fileProps: KYCQuestionProps;
	let typeFileProps: KYCQuestionProps | undefined;
	let verso: KYCQuestionProps;
	let canHaveRectoVerso = false;
	let toggleVersoOnProps = {
		checked: false,
		label: $t('forms.versoOnSecondFile')
	};
	$: if (props?.questions) {
		typeFileProps = typeFileProps?.value
			? typeFileProps
			: findPropsByApiKey(props?.questions, 'documents');

		fileProps = fileProps?.value
			? fileProps
			: props?.questions?.find((element) => element?.props?.type === KYCQuestionType.INPUT_FILE)
					?.props;
		verso = findPropsByApiKey(props?.questions, `${fileProps.apiKeys}Verso`);
	} else {
		fileProps = props;
	}
	$: if (!toggleVersoOnProps?.checked && verso?.value) {
		verso.value = null;
	}

	onMount(() => {
		props.classNames = 'w-full';
		typeFileProps = typeFileProps
			? Object.assign('typeFileProps', {
					...typeFileProps,
					placeholder: props?.placeholder,
					required: true
			  })
			: undefined;
	});

	if (typeFileProps) {
		props.classNames = 'w-full';
	}

	$: {
		canHaveRectoVerso =
			typeFileProps?.value === TypeDocumentIdentiteEnum.CNI ||
			typeFileProps?.value === TypeDocumentIdentiteEnum.CARTE_SEJOUR ||
			typeFileProps?.value === TypeDocumentIdentiteEnum.PERMIS;
	}
</script>

{#if !props.readonly}
	{#if typeFileProps && !fileProps.state}<div class="mb-3">
			<InputSelect bind:props={typeFileProps} />
		</div>
	{/if}

	{#if canHaveRectoVerso}
		<Toggler bind:props={toggleVersoOnProps} />
	{/if}
{/if}
{#if typeFileProps && !props?.readonly}
	{#if typeFileProps?.value}
		{#if toggleVersoOnProps?.checked && canHaveRectoVerso}
			<div class="my-4">
				<h4 class="mb-2 text-start">{$t('kyc.inputs.uploadRectoID')}</h4>
				<InputFileKYC bind:props={fileProps} />
			</div>
			<div>
				<h4 class="mb-2 text-start">{$t('kyc.inputs.uploadVersoID')}</h4>
				<InputFileKYC bind:props={verso} />
			</div>
		{:else}
			<div class="my-4"><InputFileKYC bind:props={fileProps} /></div>
		{/if}
	{/if}
{:else}
	<div class="my-4"><InputFileKYC bind:props={fileProps} /></div>
{/if}
